import React from "react";
import { Box, Typography } from "@mui/material";

import { customerLogos } from "../assets/catalog";

export default function KeyCustomersMarquee() {
  return (
    <Box
      sx={{
        py: 6,
        background: "linear-gradient(180deg, #eef6ee 0%, #e4f0e3 60%, #f7faf7 100%)",
        overflow: "hidden",
        position: "relative",
      }}
    >
      {/* Blobs */}
      <Box sx={{
        position: "absolute", borderRadius: "50%", filter: "blur(100px)", pointerEvents: "none",
        width: { xs: 240, md: 480 }, height: { xs: 240, md: 480 },
        top: -160, right: -100, background: "rgba(98,129,65,0.10)",
      }} />
      <Box sx={{
        position: "absolute", borderRadius: "50%", filter: "blur(100px)", pointerEvents: "none",
        width: { xs: 160, md: 320 }, height: { xs: 160, md: 320 },
        bottom: -80, left: -60, background: "rgba(139,174,102,0.10)",
      }} />

      {/* Grid overlay */}
      <Box sx={{
        position: "absolute", inset: 0, pointerEvents: "none",
        backgroundImage: "linear-gradient(rgba(98,129,65,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(98,129,65,0.03) 1px, transparent 1px)",
        backgroundSize: "52px 52px",
      }} />
      {/* Heading */}
      {/* Header */}
      <Box
        sx={{
          width: "85%",
          mx: "auto",
          px: {
            xs: "20px",
            md: "40px",
          },
          mb: { xs: 4, md: 5 },
        }}
      >
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            mb: 1.2,
          }}
        >
          <Box
            sx={{
              width: "28px",
              height: "2px",
              bgcolor: "#628141",
              borderRadius: "2px",
            }}
          />

          <Typography
            sx={{
              fontSize: "11px",
              fontWeight: 700,
              letterSpacing: ".12em",
              textTransform: "uppercase",
              color: "#628141",
            }}
          >
            Trusted By Industry
          </Typography>
        </Box>

        <Typography
          sx={{
            fontFamily: "'Barlow Condensed', sans-serif",
            fontSize: {
              xs: "2rem",
              md: "2.7rem",
            },
            fontWeight: 800,
            color: "#111",
            lineHeight: 1.05,
            letterSpacing: "-0.02em",
            mb: 1,
          }}
        >
          Our Key <span style={{ color: "#628141" }}>Customers</span>
        </Typography>

        <Typography
          sx={{
            fontSize: "15px",
            color: "#5b5b5b",
            lineHeight: 1.7,
            maxWidth: "540px",
          }}
        >
          Trusted refrigeration and HVAC partners who rely on our industrial-grade products and solutions.
        </Typography>
      </Box>

      {/* Marquee Wrapper */}
      <Box
        sx={{
          overflow: "hidden",
          whiteSpace: "nowrap",
          position: "relative",
          width: "100%",
        }}
      >
        {/* Track */}
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            animation: "marquee 30s linear infinite",
          }}
        >
          {[...customerLogos, ...customerLogos].map((customer, index) => (
            <Box
              key={index}
              sx={{
                width: 200,
                height: 110,
                mx: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#fff",
                borderRadius: "12px",
                border: "1px solid #ececec",
                transition: "all 0.3s ease",

                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 12px 30px rgba(0,0,0,0.08)",
                },
              }}
            >
              <Box
                component="img"
                src={customer.logo}
                alt={`${customer.name} logo`}
                sx={{
                  maxWidth: 168,
                  maxHeight: 76,
                  objectFit: "contain",
                  filter: "grayscale(10%)",
                  transition: "0.3s",

                  "&:hover": {
                    transform: "scale(1.05)",
                  },
                }}
              />
            </Box>
          ))}
        </Box>
      </Box>

      {/* Animation */}
      <style>
        {`
          @keyframes marquee {
            0% {
              transform: translateX(0);
            }

            100% {
              transform: translateX(-50%);
            }
          }
        `}
      </style>
    </Box>
  );
}